<div id="blocker" class="p-4">
  <div class="d-flex gap-2 flex-column">
    <p class="d-flex align-items-center">
      <i class="material-icons">warning</i> {{"SHOWROOM_MODE"|translate}} {{"ACTIVE"|translate | lowercase}}
    </p>
    <button class="btn btn-dark" (click)="viewPage()">{{"VIEW"|translate}}</button>
    <button class="btn btn-dark" (click)="toHomepage()">{{"BACK_TO_HOME"|translate}}</button>
  </div>
</div>
